const gitInfo = { commit: "7fcbd71", date: "2025-05-08T16:10:18+02:00" } 
 export default gitInfo 
